import { Box, Chip } from '@mui/material';

import type { TableHeadCellProps } from '../../head/table-head-custom';

// ----------------------------------------------------------------------

type RowCellMultiSelectProps = {
  value: any;
  headCell: TableHeadCellProps;
};

// ----------------------------------------------------------------------

export function RowCellMultiSelect({ value, headCell }: RowCellMultiSelectProps) {
  if (!value) return null;

  // Check if it's a multiSelect field type
  if (headCell.type !== 'multiSelect') return null;

  let values: string[] = [];

  // Parse the value - could be array, comma-separated string, or single value
  if (Array.isArray(value)) {
    values = value.map((v) => String(v).trim()).filter((v) => v);
  } else if (typeof value === 'string') {
    values = value
      .split(',')
      .map((v) => v.trim())
      .filter((v) => v);
  }

  if (values.length === 0) return null;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
      {values.slice(0, 2).map((val) => (
        <Chip key={val} label={val} size="small" variant="soft" />
      ))}
      {values.length > 2 && <Chip label={`+${values.length - 2}`} size="small" variant="soft" />}
    </Box>
  );
}
